<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Exportera kontakter </v-card-title>

      <v-card-text>
        <v-radio-group v-model="exportType" row>
          <v-radio label="Excel" value="excel"></v-radio>
          <v-radio label="Email-lista" value="email"></v-radio>
        </v-radio-group>
        <div class="body-2 count-info"><v-icon small color="green">mdi-information-outline</v-icon>Exportera {{ meta.totalRecords }} kontakter</div>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="onCancel"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!exportType" :loading="loading" @click="onSave">
          Exportera
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import api from '@/store/api'
import exportFromJSON from 'export-from-json'
import { timestampFileSystemCompatible } from '../../lib/misc'
export default {
  name: 'ContactExport',
  data() {
    return {
      visible: true,
      loading: false,
      exportType: null,
    }
  },
  created() {
    this.addContactsFilter({ key: 'pageSize', value: 10000000 })
  },
  computed: {
    ...mapGetters('contacts', { queryString: 'queryString', tags: 'tags', meta: 'getMeta' }),
  },
  methods: {
    ...mapMutations('contacts', { addContactsFilter: 'ADD_FILTER' }),
    onCancel() {
      this.addContactsFilter({ key: 'pageSize', value: 30 })
      this.$router.replace({ name: 'ContactsHome' })
    },

    downloadFile() {
      const link = document.createElement('a')
      const content = document.querySelector('textarea').value
      const file = new Blob([content], { type: 'text/plain' })
      link.href = URL.createObjectURL(file)
      link.download = 'sample.txt'
      link.click()
      URL.revokeObjectURL(link.href)
    },

    async onSave() {
      this.loading = true
      const resource = 'contact'
      const {
        data: { data },
      } = await api.get(`/${resource}${this.queryString}`)
      let dataToExport
      let exportType
      switch (this.exportType) {
        case 'excel':
          exportType = exportFromJSON.types.xls
          dataToExport = data.map((row) => {
            return {
              ...row,
              contact_tags: row.contact_tags
                .map((r) => r.tagId)
                .map((r) => this.tags.find((t) => t.id === r).name)
                .join(', '),
            }
          })
          break
        case 'email':
          exportType = exportFromJSON.types.txt
          dataToExport = data.map((contact) => contact.contact_mail).join(', ')
          break
        default:
          break
      }

      const fileName = `kontakter-export-${timestampFileSystemCompatible()}`
      exportFromJSON({ data: dataToExport, fileName, exportType })
      this.loading = false
      //   this.addContactsFilter({ key: 'pageSize', value: 30 })
      //   this.$router.replace({ name: 'ContactsHome' })
    },
  },
}
</script>

<style lang="less" scoped>
.count-info{
    display: flex;
    align-items: center;
    gap:5px;
    font-size: 12px;
    color: #999;
  }
</style>
